import React from 'react';
import { motion } from 'framer-motion';
import { Award, Heart, Users } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="section-padding bg-[#222222] relative" data-testid="about-section">
      <div className="art-deco-pattern" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative h-[500px] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1574071318508-1cdbab80d002?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                alt="Piatto gourmet Rovèscio"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#222222] via-transparent to-transparent" />
            </div>
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-[#FFDA00] mb-4 font-semibold">
              Chi Siamo
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
              data-testid="about-title"
            >
              La Nostra Storia
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Rovèscio è più di un ristorante: è un'esperienza culinaria che fonde tradizione italiana e design Art Deco contemporaneo. Situato a Roma in Via Eschilo 85, presso l'Eschilo Sporting Village, offriamo un ambiente sportivo ed informale dove gusto e stile si incontrano.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              La nostra filosofia? <strong className="text-[#FFDA00]">#VIVIALROVESCIO</strong> – vivere al contrario, rompere gli schemi, celebrare ogni momento con autenticità e passione. Dai crudi di pesce alle pizze fatte a regola d'arte, ogni piatto racconta la nostra dedizione alla qualità.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
              <div className="text-center" data-testid="about-feature-quality">
                <Award className="text-[#FFDA00] mx-auto mb-3" size={40} />
                <h4 className="font-bold text-white mb-1">Qualità</h4>
                <p className="text-gray-400 text-sm">Ingredienti freschi e selezionati</p>
              </div>
              <div className="text-center" data-testid="about-feature-passion">
                <Heart className="text-[#FFDA00] mx-auto mb-3" size={40} />
                <h4 className="font-bold text-white mb-1">Passione</h4>
                <p className="text-gray-400 text-sm">Amore per la cucina italiana</p>
              </div>
              <div className="text-center" data-testid="about-feature-atmosphere">
                <Users className="text-[#FFDA00] mx-auto mb-3" size={40} />
                <h4 className="font-bold text-white mb-1">Atmosfera</h4>
                <p className="text-gray-400 text-sm">Ambiente elegante e accogliente</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
